import React from "react";
import { Routes, Route } from "react-router-dom";
import GamesListingScreen from "../GamesListingScreen";
import GameScreen from "../components/GameScreen";

const PublicRoute = () => {
  return (
    <Routes>
      <Route path="/games" element={<GamesListingScreen />} />
      <Route path="/games/:slug" element={<GameScreen />} />
    </Routes>
  );
};

export default PublicRoute;
